import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface SatGuardProps {
  children: ReactNode;
  redirectTo?: string;
}

/**
 * SatGuard component that restricts access to SAT features.
 * Only allows access if the user has satEnabled === true.
 * Should be used inside ProtectedRoute to ensure user is authenticated first.
 *
 * Risk note: The satEnabled flag is checked client-side for UI gating,
 * but all SAT question endpoints are also server-side protected with @PreAuthorize("hasRole('ADMIN')").
 */
export function SatGuard({ children, redirectTo = '/dashboard' }: SatGuardProps) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.satEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
